// request.js
import axios from "axios";
import Vue from "vue";
import * as  localStore from '../store/localstore.js'
import * as tosat from '../components/common/toast.js'
// import router from '../router/index'
let app = new Vue();
Vue.prototype.$bus = app

// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// 请求拦截器
axios.interceptors.request.use(config => {
    if(config.method == 'post'){ //
        // let saveToken =  localStore.getLoginToken()
        //将token放到请求头发送给服务器,将tokenkey放在请求头中
        config.headers['Content-Type'] = 'application/json;text/plain'
        // config.headers['Authorization'] = 'Bearer ' + saveToken
    }
    return config;
  }, function(error) {
    return Promise.reject(error);
  })
  // 响应拦截器
axios.interceptors.response.use(function(response) {
    // 校验token有效期
    let expired = checkTokenExpire()
    let requireLogin = response.request.method == 'post'
    if(requireLogin && expired){
      app.$bus.$emit('OPEN_LOGIN_DIALOG')
    }
    if(response.data.code == 401){
        // 用户未登录
        // router.push({ name: "Login", params: { type: 'login' } }).catch(err => {
        //     // console.log(err)
        //     // console.log('跳转失败！')
        //   })
        // console.log('响应拦截',response)
        app.$bus.$emit('OPEN_LOGIN_DIALOG')
    }
    return response;
}, function(error) {
  return Promise.reject(error);
})

function checkTokenExpire(){
  let expire = localStore.getTokenExpireTime()
  if(expire != undefined){
    let curr = new Date().getTime()
    let detla = expire - curr
    // 提前一个小时提示
    if(detla < (1000 * 60 * 60)){
      return true
    } 
  }
  return false;
}

//定义方法
export function postnotAuthor(url, datas, params,auth) {
    let basePath = getBasePath()
    return axios.post(basePath + url, datas,{params:params,auth:auth});
}

export function post(url, datas, params) {
    let basePath = getBasePath()
    return axios.post(basePath + url, datas,params);
}

export function postUseToken(url, params,datas) {
    let basePath = getBasePath()
    let saveToken =  localStore.getLoginToken()
    let headers = {
        Authorization:'Bearer '+ saveToken,
    }
    return axios.post(basePath + url, datas,{
        headers:headers,
        params:params
    });
}
export function postJson(url, params,datas) {
  let basePath = getBasePath()
  let headers = {
      'Content-Type': 'application/json;text/plain'
  }
  return axios.post(basePath + url,datas,{
      headers:headers,
      params:params
  });
}
export function postJsonUseToken(url, params,datas) {
  let basePath = getBasePath()
  let saveToken =  localStore.getLoginToken()
  let headers = {
      'Authorization':'Bearer '+ saveToken,
      'Content-Type': 'application/json;text/plain'
  }
  return axios.post(basePath + url,datas,{
      headers:headers,
      params:params
  });
}
// 新增保存岗位
export function postWithArray(url,data) {
    let basePath = getBasePath()
    let saveToken =  localStore.getLoginToken()
    let headers = {
        Authorization:'Bearer '+ saveToken,
    }
    return axios({
      url: basePath + url,
      method: "post",
      headers:headers,
      params: data,
      paramsSerializer: function (params) {
        let result = [];
        for (let field in params) {
          if (params[field] === undefined || params[field] === null) {
            result.push(`${field}=`);
            continue
          }
          if (Array.isArray(params[field])) {
            result.push(params[field].map(_ => `${field}=${_}`).join("&"));
          } else {
            result.push(`${field}=${encodeURIComponent(params[field])}`);
          }
        }
        return result.join("&");
      }
    });
  }
  

export function get(url, params,auth) {
    let basePath =  getBasePath()
    return axios.get(basePath + url, {params:params,auth:auth});
}

export function getUseToken(url, params) {
    let basePath =  getBasePath()
    let saveToken =  localStore.getLoginToken()
    let headers = {
        Authorization:'Bearer '+ saveToken,
        ContentType: 'application/x-www-form-urlencoded'
    }
    return axios.get(basePath + url, {params:params,headers:headers});
}
export function patch(url, datas, params) {
    let basePath =  getBasePath()
    return axios.patch(basePath + url, datas, params);
}

export function remove(url, params) {
    let basePath =  getBasePath()
    return axios.delete(basePath + url, params);
}

export function put(url, datas, params) {
    let basePath =  getBasePath()
    return axios.put(basePath + url, datas, params);
}


function getBasePath() {
    var basePath = 
            basePath = process.env.NODE_ENV == "development" ? process.env.BASE_API : process.env.BASE_API;
    return basePath
}


// WEBPACK FOOTER //
// ./src/api/request.js